import React, { Component } from 'react'
import BezierEasing from 'bezier-easing'

export default class AnimatedPaths extends Component {

    /**
     * Add this to SVG paths to get them to 'draw' in
  transition: all ease-out 5s;
  stroke-dashoffset: -1700; // animate to transition to 0
  stroke-dasharray: 1700;
     */

    currentScroll
    startSteps = 0
    dashLength = 3
    updateInterval
    easing = BezierEasing(.22,.01,.84,.57)

    constructor(props){
        super(props);
        this.state = {
            ticking: false,
            lastKnownScrollPosition: 0
        };
    }

    componentDidMount() {
        this.props.onRef(this);
        window.addEventListener('scroll', this.onScroll)
        window.addEventListener('resize', this.onScroll)
        this.onScroll()
        //this.updateInterval = setInterval(() => this.updatePath(), 100)
    }

    componentWillUnmount() {
        this.props.onRef(undefined);
        this.stopListening();
        //clearInterval(this.updateInterval)
    }

    stopListening() {
        window.removeEventListener('scroll', this.onScroll)
        window.removeEventListener('resize', this.onScroll)
    }

    onScroll = () => {
        this.lastKnownScrollPosition = window.scrollY;

        if (!this.ticking) {
          window.requestAnimationFrame(() => {
            this.scrollAction();
            this.setState({ticking: false});
          });
      
          this.setState({ticking: true});
        }

    };

    scrollAction = () => {
        Array.from(document.getElementsByClassName('visibleOnScroll')).forEach((element) => {

            if (!element.classList.contains("visible")) {
                const visibleTriggerRatio = .01;
                const pos = window.scrollY + window.innerHeight;
                const pageYOffset = window.scrollY || document.documentElement.scrollTop;
                const box = element.getBoundingClientRect();
                const top = box.top + (box.height * visibleTriggerRatio) + (pageYOffset);
                //const path = element.getElementsByTagName('path').item(0)
                if (top < pos) {
                    element.classList.add("visible");
                    // this.setupDashedPath(path)
                }
                // const body = document.body,
                //     html = document.documentElement;
                // let pageHeight = Math.max( body.scrollHeight, body.offsetHeight,
                //     html.clientHeight, html.scrollHeight, html.offsetHeight );

                // this.currentScroll = Math.max(
                //     (pageYOffset) / (pageHeight -  window.innerHeight),
                //     0
                // )

            }
        })
    }

    updatePath = () => {
        Array.from(document.getElementsByClassName('visibleOnScroll')).forEach((element) => {
            const path = element.getElementsByTagName('path').item(0)
            let pathLength = path.getTotalLength(),
                numberOfSteps = Math.round(pathLength / (this.dashLength * 2) + 1);

            if (this.startSteps < 50)
                this.startSteps ++

            let totalPercentage = this.easing(this.currentScroll) * .7 + (.3 * this.startSteps * .02)
            console.log(parseInt(totalPercentage * numberOfSteps ) * this.dashLength * 2)
            path.setAttribute("stroke-dashoffset", parseInt(totalPercentage * numberOfSteps ) * this.dashLength * 2 + pathLength);
        })
    }

    // Animates the given path element with given dash length, animation duration and direction
    setupDashedPath (path) {

        let pathLength = path.getTotalLength(),
            numberOfSteps = Math.round(pathLength / (this.dashLength * 2) + 1);

        // Build the dash array so we don't have to do it manually
        let dashArray = [pathLength, pathLength];
        for (let i = numberOfSteps; i > 0; i--) {
            dashArray.push(this.dashLength);
            dashArray.push(this.dashLength);
        }
        dashArray.push(pathLength);
        dashArray.push(pathLength);

        // Animation start conditions
        path.setAttribute("stroke-dasharray", dashArray.join(" "));
        path.setAttribute("stroke-dashoffset", pathLength);

    }

    render() {
        return (
            <></>
        )
    }
}